import { getCMSConfig } from '../../../util/cms';

export const filterOnlyRelevantIds = (unfilteredArray: string[]) => {
    if (!unfilteredArray) {
        return [];
    }

    const cmsFiberIds = Object.values(getCMSConfig().lifeCycleIds);
    const fiberIds = unfilteredArray.filter(item => cmsFiberIds.includes(item));
    const dslIds = unfilteredArray.filter(metacode => metacode.match(/DSL-.+/g));
    // TODO: filter fastest DSL with Jarvis

    return fiberIds.concat(dslIds);
};

export const filterOnlyMarketedPreFiberIds = (unfilteredArray: string[]) => {
    if (!unfilteredArray) {
        return [];
    }

    const marketedIds = Object.values(getCMSConfig().tariffIds);

    return unfilteredArray.filter(item => marketedIds.includes(item));
};
